import React from 'react';
import { Target, Eye, Heart, Users } from 'lucide-react';
import { useLang, tx } from '../i18n/LanguageContext';
import StatsSection from '../components/StatsSection';

const About = () => {
  const { t, lang } = useLang();
  return (
    <main className="page-y min-h-screen">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-9">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mb-3">{t.about.title}</h1>
          <p className="text-slate-600 leading-relaxed max-w-2xl mx-auto">{t.about.desc}</p>
        </div>
        <div className="grid md:grid-cols-2 gap-5 mb-8 sm:mb-9">
          <div className="rounded-2xl bg-white border border-slate-200 p-6">
            <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center mb-4"><Target className="w-6 h-6 text-blue-600" /></div>
            <h3 className="text-slate-900 font-bold text-xl mb-2">{t.about.mission}</h3>
            <p className="text-slate-600 leading-relaxed">{t.about.missionText}</p>
          </div>
          <div className="rounded-2xl bg-white border border-slate-200 p-6">
            <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center mb-4"><Eye className="w-6 h-6 text-blue-600" /></div>
            <h3 className="text-slate-900 font-bold text-xl mb-2">{t.about.vision}</h3>
            <p className="text-slate-600 leading-relaxed">{t.about.visionText}</p>
          </div>
        </div>
        <StatsSection />
        <div className="grid sm:grid-cols-2 gap-5 mt-8">
          <div className="rounded-2xl bg-white border border-slate-200 p-6 flex items-start gap-4">
            <Heart className="w-8 h-8 text-pink-400 shrink-0" />
            <div>
              <h4 className="text-slate-900 font-bold mb-1">{tx(lang, 'شغف بالتعليم', 'Passion for Education')}</h4>
              <p className="text-slate-500 text-sm">{tx(lang, 'نصنع محتوى عربي عالي الجودة', 'We craft high-quality Arabic content')}</p>
            </div>
          </div>
          <div className="rounded-2xl bg-white border border-slate-200 p-6 flex items-start gap-4">
            <Users className="w-8 h-8 text-blue-600 shrink-0" />
            <div>
              <h4 className="text-slate-900 font-bold mb-1">{tx(lang, 'مجتمع نشط', 'Active Community')}</h4>
              <p className="text-slate-500 text-sm">{tx(lang, 'آلاف المهندسين والفنيين', 'Thousands of engineers and technicians')}</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default About;
